import Banner from "/@/views/home/chlid-page/Banner.vue";
import Notice from "/@/views/home/chlid-page/Notice.vue";
import { useHot } from "/@/kernel-mn/stores/useHot";
import { GET_WEB_Menu, getBigGameListByType } from "/@/hooks/publicData";
import { computed, onMounted, ref, watch, onBeforeUnmount } from "vue";
import { mb_t, mb_toast, tResLoc } from '/@/plugins/global';
import { getBlanceCollect, getHallListSync, getPC28List, getTransitionAllYe } from "/@/hooks/gameActions";
import { mb_getLogoById } from "/@/hooks/publicData";
import { useSportsStore } from '/@/kernel-mn/stores/sports'
import { useMsgStore } from '/@/kernel-mn/stores/message';
import { G_goLogin, currencyMoney } from "/@/hooks/common";
import { useEnhancer } from '/@/plugins/enhancer';
import { useUserStore } from '/@/kernel-mn/stores/user';
import ActivitySelector from "./ActivitySelector.vue";
import { getUnreadNum } from '/@/hooks/message';

export default {
  name: "Home",
  components: { Banner, Notice, ActivitySelector },
  setup() {
    const { hotData: { userInfo, isLogined }, activeConfiguration } = useHot();
    const userStore = useUserStore();
    const useSports = useSportsStore();
    const messageStore = useMsgStore();
    const { router } = useEnhancer();
    // 选中的tab
    let active = ref(-1);
    let currentTab = ref({});
    let webmenu = computed(() => {
      let menu = GET_WEB_Menu();
      menu.length && (active.value = menu[0].id);
      return menu;
    });
    const currentGameName = computed(() => {
      const _menu = webmenu.value.find(v => v.id === active.value);
      return _menu.title;
    });
    const unRead = computed(() => messageStore.webNewsUnread || 0);
    const lotteryLoad = ref(false)
    const showRight = ref(false);
    const gameContainerBefore = ref<HTMLElement>(null);
    const isgameContainerBeforeVisible = ref(false);
    // let blockList = ref([]); // 原创 哈希游戏
    const getCurrentType = (id) => {
      let item = webmenu.value.find(item => item.id === id);
      if (item.key === 'lottery') {
        loadLotteryList()
      }
      if (item.key === 'lotterypc28') {
        getPC28List({ play_cat: 1, size: 16, type: 2 }, true)
      }
      currentTab.value = item;
    };

    const loadLotteryList = async () => {
      lotteryLoad.value = false
      try {
        // @ts-ignore
        await getHallListSync({ type: 0 }); // 如果是彩票
      } finally {
        lotteryLoad.value = true
      }
    }

    const gameAllData = computed(() => {
      const _datas = webmenu.value.map((v) => {
        let len = undefined
        if (['themeKYMN'].includes(tResLoc().value)) {
          len = {lottery: 6, block: 6, chess: 4, electronic: 4, fishing: 4, live: 6, sports: 7 }[v.key] || undefined;
        }
        let childrens = getBigGameListByType(v.key, len);
        if(v.key === 'sports') {
          childrens = childrens.filter(o => o.play_id != 1310)
        }
        return {
          ...v,
          childrens,
        }
      })
      // console.log('--gameAllData-', _datas)
      return _datas
    })
    // 彩票
    const getCurrentGameList = () => {
      let item: any = currentTab.value; // 当前选中的tab[真人/体育等]
      let d = getBigGameListByType(item.key);
      return d;
    };

    const tabsScrollTo = (dom, value) => {
      const domWrapper = document.querySelector(dom);
      domWrapper.scrollTo(0, value);
    }

    // let lotteryList = computed(getCurrentGameList);
    watch(active, nv => {
      getCurrentType(+nv);
    });
    const changeTab = (nv) => {
      isProgrammaticScroll.value = true;
      active.value = nv
      const currentIndex = gameAllData.value.findIndex(v => nv === v.id)
      let scrollHeight = 0
      if (currentIndex > 0) {
        for (let i = 0; i < currentIndex; i++) {
          // @ts-ignore
          scrollHeight += document.querySelectorAll('.van-tab__panel')[i].offsetHeight;
        }
      }
      if (['themeKYMN'].includes(tResLoc().value)) {
        tabsScrollTo('.layout-content', scrollHeight + 150)
      } else {
        tabsScrollTo('.van-tabs__content', scrollHeight)
      }
    }

    const gameData = computed(() => {
      return getCurrentGameList()
    });

    const blanceActive = ref(false)
    const blance = computed(() => {
      return useSports.blance;
    });

    const transitionAllYe = async () => {
      blanceActive.value = true;
      try {
        await getTransitionAllYe({}, null, blanceActive);
        mb_toast(mb_t('刷新成功'), 1);
      } catch (e) { /* empty */ }
    };

    const goPage = (path) => {
      if (isLogined.value) {
        if(userStore.isTryLogined) {
          userStore.setTryLoinInfo({ show: true, type: 2 })
        }else {
          router.push(path)
        }
        
      } else {
        G_goLogin()
      }
    }
    const homeTabs = ref();
    const tabs_content = ref();

    const debounce = (fn, delay) => {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    }

    const isProgrammaticScroll = ref(false)

    const scrollFunction = debounce((e) => {
      if (isProgrammaticScroll.value) {
        isProgrammaticScroll.value = false;
      } else {
        if (['themeKYMN'].includes(tResLoc().value)) {
          let children = tabs_content.value.children;
          // 收集小于基础Dom底部的所有panel
          let arr_panel = [];
          for (let i = 0; i < children.length; i++) {
            let item = children[i];
            if (210 > item?.getBoundingClientRect().top) {
              arr_panel.push(gameAllData.value[i].id);
            }
            if (arr_panel.length) {
              active.value = arr_panel.pop();
            }
            if (e.target.scrollTop === 0) {
              active.value = gameAllData.value[0].id
            }
          }
        } else {
          const baseDom = document.querySelector('.set-base-active');
          // 基础位置dom
          if (baseDom) {
            // 收集小于基础Dom底部的所有panel
            let arr_panel = [];
            for (let i = 0; i < e.target.children.length; i++) {
              let item = e.target.children[i];
              if (baseDom.getBoundingClientRect().bottom > item?.getBoundingClientRect().top) {
                arr_panel.push(gameAllData.value[i].id);
              }
              if (arr_panel.length) {
                active.value = arr_panel.pop();
              }
              if (e.target.scrollTop === 0) {
                active.value = gameAllData.value[0].id
              }
            }
          }
        };
      }
    }, 200);
    onMounted(() => {
      // 先获取pc28数据
      getCurrentType(999)
      loadLotteryList()
      if (isLogined.value) {
        getUnreadNum();
        getBlanceCollect();
      } 

      // 禁止左侧分类滑动
      if (['themeKYMN'].includes(tResLoc().value)) {
        document.querySelector('.layout-content').addEventListener('scroll', scrollFunction);
      } else {
        document.querySelector('.van-tabs__content').addEventListener('scroll', scrollFunction);
      }
    });
    onBeforeUnmount(() => {
      if (['themeKYMN'].includes(tResLoc().value)) {
        document.querySelector('.layout-content').removeEventListener('scroll', scrollFunction);
      } else {
        document.querySelector('.van-tabs__content').removeEventListener('scroll', scrollFunction);
      }
    });

    return {
      gameContainerBefore,
      isgameContainerBeforeVisible,
      gameAllData,
      currentGameName,
      goPage,
      blanceActive,
      transitionAllYe,
      currencyMoney,
      blance,
      userInfo,
      isLogined,
      activeConfiguration,
      webmenu,
      active,
      currentTab,
      // blockList,
      // lotteryList,
      mb_getLogoById,
      gameData,
      showRight,
      lotteryLoad,
      homeTabs,
      tabs_content,
      changeTab,
      unRead,
    }
  }
}